import React from 'react';

export default function AcademyExamRoomButton({ onClick, disabled = false }) {
  return (
    <button
      type="button"
      className="member-academy-exam-room-btn"
      onClick={onClick}
      disabled={disabled}
      data-resource="private.navbar.academy"
      data-action="execute"
      data-route="/api/user/academy/start-course-exam"
      data-description="Academy → Enter examination room"
    >
      <span className="member-academy-exam-room-btn__label member-academy-exam-room-btn__label--default">
        Examination room is now open
      </span>
      <span className="member-academy-exam-room-btn__label member-academy-exam-room-btn__label--hover">
        Enter the examination room
      </span>
    </button>
  );
}
